import React from 'react';
import { useContext } from 'react';
import { Context } from '../../../../context/context';
import MenuIcon from '@mui/icons-material/Menu';

const ToogleSection = () => {

    const [context, setContext] = useContext(Context);

    return (
        <MenuIcon
            className='toggle-menu-icon' 
            onClick={() => setContext(!context)}
        />
    )
};

export default ToogleSection;